module.exports = __webpack_public_path__ + "static/media/1.f8d6ba64.jpg";